export default __webpack_public_path__ + "static/media/action-plan.00d9528f.pdf";